<template>
  <div class="fill-in-wrap">
    <!-- <van-pull-refresh
      v-model="isPullLoading"
      @refresh="orderDetail"
      height="100%"
    > -->
    <van-notify v-model="isShowNotify" type="warning">
      <!-- <van-icon name="bell" style="margin-right: 4px;" /> -->
      <span>签约进度查询中...</span>
    </van-notify>
    <div class="step-box">
      <div :class="['step', +type === 1 ? 'active' : '']">
        <div class="round">绑卡</div>
        <div class="txt">{{ type == 1 ? "待完成" : "已完成" }}</div>
      </div>
      <div class="hr"></div>
      <div :class="['step', +type === 2 ? 'active' : '']">
        <div class="round">签约</div>
        <div class="txt">{{ notifyStatus == "2" ? "已完成" : "待完成" }}</div>
      </div>
    </div>
    <div class="content">
      <div class="input-wrap" v-for="(f, i) in fields" :key="i">
        <van-field
          :type="f.type"
          v-model.trim="form[f.key]"
          :label="f.title"
          name="picker"
          :maxlength="f.maxlength"
          :readonly="f.type === 'picker'"
          :placeholder="f.placeholder || `请输入`"
          :rules="required"
          required
          :disabled="f.disabled"
          input-align="right"
          @click="fieldClick(f)"
        >
          <template #label>
            {{ f.title }}
            <van-icon
              v-if="f.leftIcon"
              :name="f.leftIcon"
              :color="f.leftIconColor"
              @click="f.leftIconClick"
            />
          </template>
        </van-field>
      </div>
      <div class="input-wrap verify-code" v-if="type == '1'">
        <van-field
          label="验证码"
          v-model="form.smsCode"
          placeholder="请输入验证码"
          required
          type="digit"
          :rules="required"
        />

        <div :class="['send-btn', sending ? 'sending' : '']" @click="getCode">
          {{ sending ? `${second}s` : "获取验证码" }}
        </div>
      </div>
      <!-- <div class="input-wrap" v-if="type == '2'">
        <van-checkbox v-model="checked" shape="square">
          <span class="font_28 van-field__label"
            >我已阅读并同意<span class="link" @click.stop="openContact"
              >《委托扣款协议》</span
            >
          </span>
        </van-checkbox>
      </div> -->
    </div>
    <!-- </van-pull-refresh> -->
    <div class="btns">
      <!-- <van-button
        type="info"
        size="small"
        v-if="type == '1'"
        @click="signingAgreement"
        >代扣协议签约</van-button
      > -->
      <!-- <van-button
        type="info"
        class="info"
        v-if="type == '2'"
        size="small"
        @click="changeBankCard"
        >更换银行卡</van-button
      > -->
      <van-button type="info" size="small" v-if="type == '2'" @click="back"
        >返回</van-button
      >
      <van-button type="info" size="small" v-if="type == '1'" @click="saveFn"
        >提交</van-button
      >
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="bankList"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import {
  sendSms,
  signVerify,
  getHmBankConfigs,
  getApplyRepayCard
  // applyHmSignChange,
  // applyHmSign
} from "@/api/bindCardhm";
import { getLatestBankCardInfo } from "@/api/bindCard";
import { mapGetters } from "vuex";
import { BIZINFO } from "@/utils/token";
import { setToken } from "@/utils/app";

export default {
  name: "TokenEncryption",
  data() {
    return {
      // 输入字段类型
      enterFields: ["text", "textarea", "number", "amount"],
      required: [
        {
          required: true
        }
      ],
      form: {},
      sending: false, // loading
      second: 60,
      itv: null, // 定时器
      cacheData: {},
      checked: false, // 是否签订协议
      originalData: "",
      encryptedToken: "", // 加密后的数据
      decryptedData: "", // 解密后的数据
      secretKey: `my-super-secret-key-for-encryption-${process.env.VUE_APP_AUTH_CLIENT_SECRET}`,
      // 初始化向量
      iv: new Uint8Array([
        21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36
      ]),
      type: null,
      showPicker: false, // 控制选择器的显示
      bankList: [], // 银行列表
      isPullLoading: false, // 下拉刷新
      timmer: null, // 定时器
      notifyStatus: "1"
    };
  },
  async created() {
    // 从本地缓存里面取数据
    let { token, bizNo, type } = this.$route.query;
    this.type = type || "1";
    const data = localStorage.getItem(BIZINFO) || "{}";
    this.cacheData = JSON.parse(data);
    this.encryptedToken = token || "";
    await this.getHmBankConfigs();
    if (this.encryptedToken) {
      await this.decryptData();
      setToken(this.decryptedData);
    }
    if (this.cacheData) {
      const { customerName } = this.cacheData;
      // this.$set(this.form, "acctNo", certNo || "");
      // this.$set(this.form, "bankPhone", bankPhone || "");
      this.$set(this.form, "acctName", customerName || "");
    }
    // 从store里面取数据、或者来自于url地址
    const currentBizNo = this.getBizNoQuery() || bizNo;
    this.$set(this.form, "bizNo", currentBizNo || "");
    if (!bizNo) {
      this.$router.push("/");
      this.$toast.fail("请从短信链接进入");
    } else {
      this.type == "1" && (await this.getLatestBankCardInfo());
    }
    this.getApplyRepayCard();
    if (this.type == "2") {
      this.timmer = setInterval(() => {
        this.getApplyRepayCard();
      }, 2000);
    }
  },
  computed: {
    fields() {
      return [
        {
          title: "账户名",
          key: "acctName",
          type: "text",
          disabled: true
        },
        // {
        //   title: "身份证",
        //   key: "certNo",
        //   type: "text",
        // },
        {
          title: "银行卡",
          key: "acctNo",
          maxlength: 19,
          type: "digit",
          reg: /^[1-9]\d{9,29}$/,
          disabled: this.type == "2"
        },
        {
          title: "开户银行",
          key: "bankName",
          type: "picker",
          placeholder: "请选择",
          fieldClick: () => {
            this.showPicker = true;
          },
          disabled: this.type == "2"
        },
        {
          title: "银行预留手机号",
          key: "bankPhone",
          maxlength: 11,
          type: "digit",
          disabled: this.type == "2",
          reg: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/
        }
      ];
    },
    isShowNotify() {
      return this.type == "2";
    }
  },
  methods: {
    orderDetail() {
      // TODO: 定时刷新
      setTimeout(() => {
        this.isPullLoading = false;
      }, 1500);
    },
    //  获取线下还款卡号
    async getHmBankConfigs() {
      let { data } = await getHmBankConfigs();
      this.bankList = data.map((item) => ({
        text: item.bankName,
        code: item.bankCode
      }));
    },
    getApplyRepayCard() {
      const bizNo = this.form.bizNo;
      if (!bizNo) return;
      getApplyRepayCard(bizNo).then((res) => {
        if (res.data) {
          const {
            openBankCode,
            acctName,
            acctNo,
            certNo,
            openBankName,
            notifyStatus,
            bankPhone,
            status
          } = res.data;
          this.notifyStatus = notifyStatus;
          if (notifyStatus == "2" && status == "1") {
            this.back();
          } else {
            this.form = {
              ...this.form,
              acctName: acctName,
              certNo: certNo,
              acctNo: acctNo,
              bankName: openBankName,
              bankCode: openBankCode,
              bankPhone: bankPhone
            };
          }
        }
      });
    },
    back() {
      this.$router.replace(`/index?bizNo=${this.form.bizNo}`);
    },
    // 将字符串转换为ArrayBuffer
    strToArrayBuffer(str) {
      const encoder = new TextEncoder();
      return encoder.encode(str);
    },

    // 将ArrayBuffer转换为Base64字符串
    arrayBufferToBase64(buffer) {
      let binary = "";
      const bytes = new Uint8Array(buffer);
      const len = bytes.byteLength;
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
      }
      return window.btoa(binary);
    },

    // 将Base64字符串转换为ArrayBuffer
    base64ToArrayBuffer(base64) {
      const binaryString = window.atob(base64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      return bytes.buffer;
    },

    // 将ArrayBuffer转换为字符串
    arrayBufferToString(buffer) {
      const decoder = new TextDecoder();
      return decoder.decode(buffer);
    },

    // 生成加密密钥
    async generateKey(secretKey) {
      const keyMaterial = await window.crypto.subtle.importKey(
        "raw",
        this.strToArrayBuffer(secretKey),
        { name: "PBKDF2" },
        false,
        ["deriveKey"]
      );
      // 仅支持HTTPS && localhost
      return window.crypto.subtle.deriveKey(
        {
          name: "PBKDF2",
          salt: this.strToArrayBuffer("a-unique-salt-value"),
          iterations: 100000,
          hash: "SHA-256"
        },
        keyMaterial,
        { name: "AES-GCM", length: 256 },
        false,
        ["encrypt", "decrypt"]
      );
    },

    // 加密数据
    async encryptData() {
      try {
        if (!this.originalData) throw "请输入要加密的数据";
        const key = await this.generateKey(this.secretKey);
        // 仅支持HTTPS && localhost
        const encrypted = await window.crypto.subtle.encrypt(
          {
            name: "AES-GCM",
            iv: this.iv
          },
          key,
          this.strToArrayBuffer(this.originalData)
        );
        this.encryptedToken = this.arrayBufferToBase64(encrypted);
        this.decryptedData = ""; // 清空解密结果
      } catch (error) {
        this.$errMsg(error);
      }
    },

    // 解密数据
    async decryptData() {
      try {
        if (!this.encryptedToken) throw "请先加密数据";
        const key = await this.generateKey(this.secretKey);
        // 仅支持HTTPS && localhost
        const decrypted = await window.crypto.subtle.decrypt(
          {
            name: "AES-GCM",
            iv: this.iv
          },
          key,
          this.base64ToArrayBuffer(this.encryptedToken)
        );
        this.decryptedData = this.arrayBufferToString(decrypted);
      } catch (error) {
        this.$errMsg("解密失败，请查看控制台获取详细信息");
      }
    },
    ...mapGetters(["getBizNoQuery"]),
    // 校验
    checkedFields() {
      for (let i = 0; i < this.fields.length; i++) {
        const f = this.fields[i];
        const k = f.key;
        const name = f.title;
        const reg = f.reg;
        if (!this.form[k]) throw `${name}不能为空`;
        if (reg && !reg.test(this.form[k])) throw `请输入正确的${name}`;
      }
    },
    openContact() {
      const url =
        "https://songcw-dev.oss-cn-shanghai.aliyuncs.com/agreement/%E4%BB%A3%E6%89%A3%E5%8D%8F%E8%AE%AE.pdf";

      this.$router.push(
        `/pdf?title=委托扣款协议&url=${encodeURIComponent(url)}`
      );
    },

    // 银行卡认证信息
    async getLatestBankCardInfo() {
      try {
        if (!this.form.bizNo) throw "订单编号错误";
        const res = await getLatestBankCardInfo(this.form.bizNo);
        const { accNo, idCard, mobile, name } = res.data || {};
        if (res.data) {
          this.form = {
            ...this.form,
            acctNo: accNo,
            certNo: idCard,
            bankPhone: mobile,
            ...(name ? { acctName: name } : {})
          };
        }
      } catch (error) {
        this.$errMsg(error);
      }
    },
    // 获验证码
    async getCode() {
      if (this.sending) return;
      try {
        if (!this.form.certNo) {
          throw "缺少持卡人身份证号码";
        }
        this.checkedFields();
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true
        });
        // 执行后续动作
        let redirectUrl =
          location.origin +
          "/bankCardhm?token=" +
          this.encryptedToken +
          "&type=2&bizNo=" +
          this.form.bizNo;
        const res = await sendSms({ ...this.form, redirectUrl });

        setTimeout(() => {
          this.$toast.success("验证码已发送，请注意查收！");
        }, 100);
        this.sending = true;
        this.itv = setInterval(() => {
          this.second--;
          if (this.second <= 0) {
            this.second = 60;
            this.sending = false;
            clearInterval(this.itv);
          }
        }, 1000);
        return Promise.resolve(true);
      } catch (error) {
        this.sending = false;
        this.$errMsg(error);
        return Promise.reject(error);
      }
    },
    // 获取银行列表
    async saveFn() {
      try {
        if (!this.form.smsCode) {
          throw "请输入验证码";
        }
        this.checkedFields();
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true
        });
        let { data } = await signVerify({
          bizNo: this.form.bizNo,
          smsCode: this.form.smsCode
        });
        this.$toast.clear();
        if (this.notifyStatus == "2") {
          this.back();
        } else {
          window.location.href = data;
        }
        setTimeout(() => {
          this.$toast.success("绑卡成功");
        }, 100);
      } catch (error) {
        this.$errMsg(error);
      }
    },

    // 更换银行卡
    // async changeBankCard() {
    //   Dialog.confirm({
    //     title: "提示",
    //     message: "确认是否要更换银行卡？"
    //   })
    //     .then(async () => {
    //       try {
    //         await applyHmSignChange({
    //           bizNo: this.form.bizNo
    //         });
    //         this.$router.replace({
    //           path: "/bankCardhm",
    //           query: { bizNo: this.form.bizNo }
    //         });
    //       } catch (error) {
    //         this.$errMsg(error);
    //       }
    //     })
    //     .catch(() => {
    //       // on cancel
    //     });
    // },
    // 选择器确认
    onConfirm(selected) {
      this.form.bankName = selected.text;
      this.form.bankCode = selected.code;
      this.showPicker = false;
    },

    // 代扣协议签约
    // async signingAgreement() {
    //   try {
    //     // this.originalData ='ff07c26b-bdb4-48a4-b0df-23bd17e800f2';
    //     if (!this.form.customerIdCardNo) {
    //       throw "缺少持卡人身份证号码";
    //     }
    //     this.checkedFields();
    //     this.originalData = getToken();
    //     await this.encryptData();
    //     applyHmSign({
    //       ...this.form
    //     });
    //   } catch (error) {
    //     this.$errMsg(error);
    //   }
    // },
    // 处理点击事件
    fieldClick(f) {
      if (f.fieldClick && typeof f.fieldClick === "function") {
        this.type == "1" && f.fieldClick();
      }
    }
  },
  beforeDestroy() {
    this.timmer && clearInterval(this.timmer);
    this.itv && clearInterval(this.itv);
  }
};
</script>

<style lang="scss" scoped>
/deep/.van-pull-refresh {
  height: 100%;
}
.fill-in-wrap {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f8f8f8;

  .step-box {
    height: 456px;
    background: url("/images/index/bank-bg.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 80px 30px 80px;
    .step {
      font-size: 28px;
      opacity: 0.48;
      min-width: 120px;
      .round {
        width: 80px;
        height: 80px;
        line-height: 80px;
        background: #ffffff;
        border-radius: 50%;
        color: #2396f5;
        text-align: center;
        margin: auto;
      }
      .txt {
        margin-top: 16px;
        color: #333;
        text-align: center;
      }
    }
    .hr {
      opacity: 0.4;
      width: 330px;
      height: 50px;
      border-top: 4px dashed #fff;
    }
    .active {
      opacity: 1;
      .round {
        line-height: 64px;
        border: 8px solid #a6cbff;
      }
    }
  }
  .link {
    color: #1890ff;
    text-decoration: underline;
    cursor: pointer;
  }
  .content {
    flex: 1;
    overflow-y: auto;
    margin-top: -120px;
    .input-wrap {
      width: 100%;
      height: 96px;
      display: flex;
      align-items: center;
      overflow: hidden;
      padding: 0 32px;
      /deep/.van-field--disabled .van-field__label {
        color: #646566;
      }
      :deep(.van-field__label) {
        width: 7em;
      }
      &.verify-code {
        display: flex;
        justify-content: space-between;
        .send-btn {
          box-sizing: border-box;
          height: 90%;
          background-color: #fff;
          align-content: center;
          font-size: 28px;
          font-weight: 400;
          color: #fff;
          text-align: center;
          padding-left: 6px;
          white-space: nowrap;
          padding: 0px 32px;
          position: relative;
          background-color: #1890ff;
          // &::after {
          //   position: absolute;
          //   left: 0;
          //   top: 50%;
          //   transform: translateY(-50%);
          //   content: "";
          //   display: inline-block;
          //   width: 1px;
          //   height: 50%;
          //   background-color: #1890ff;
          // }
          &.sending {
            color: #999;
          }
        }
      }
    }
  }
  .btns {
    bottom: 0;
    border-top: 1px solid #efefef;
    height: 112px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    box-shadow: 0 -5px 10px #efefef;
    padding: 0 20px;
    background-color: #fff;
    .van-button {
      width: 90%;
      height: 75%;
      font-size: 28px;
      &.info {
        background-color: #fff;
        border: 1px solid #1989fa;
        color: #1989fa;
      }
    }
    .van-button + .van-button {
      margin-left: 20px;
    }
  }
}
</style>
